import de from "@/i18n/de.json";

/**
 * Tiny i18n helper. The product ships German-only for the MVP, so this is a
 * flat lookup with named-token interpolation rather than a full ICU library.
 *
 * All UI strings live in src/i18n/de.json (AGENTS.md constitution §5). Never
 * hardcode German in components — call `t("path", tokens?)` instead.
 *
 * Token syntax in the catalog: `"{name}"`. Example:
 *   t("legality.red.detail", { categories: "Schule" })
 *   → "Verboten: im Umkreis von Schule"
 */

type Dict = Record<string, unknown>;

const catalog: Dict = de as Dict;

/** Look up a dotted path in the catalog, returning the fallback on miss. */
function lookup(path: string): string {
  const parts = path.split(".");
  let cur: unknown = catalog;
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in (cur as Dict)) {
      cur = (cur as Dict)[p];
    } else {
      return path; // Missing key → return the key itself as a dev signal.
    }
  }
  return typeof cur === "string" ? cur : path;
}

/**
 * Translate a catalog key, substituting `{token}` placeholders.
 * Missing tokens are left as-is; missing keys return the key path.
 */
export function t(path: string, tokens?: Record<string, string | number>): string {
  let s = lookup(path);
  if (tokens) {
    for (const [k, v] of Object.entries(tokens)) {
      s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
    }
  }
  return s;
}

export { catalog };
